<mat-toolbar class="main-app-toolbar">
  <mat-toolbar-row class="toolbar-content-row">
    <div class="toolbar-left-group">
      <button
        mat-icon-button
        type="button"
        class="btn-drawer-toggle"
        (click)="handleToggleDrawer()"
        [attr.aria-label]="
          openDrawer ? 'Cerrar menú lateral' : 'Abrir menú lateral'
        "
        matTooltip="Alternar menú lateral"
      >
        <i-tabler
          [name]="openDrawer ? 'layout-sidebar-left-collapse' : 'menu-2'"
          class="toggle-icon"
        ></i-tabler>
      </button>

      <a
        class="nav-brand-logo-link"
        [routerLink]="'/home'"
        matTooltip="Inicio - Portal de Alimentos & Bebidas"
      >
        <img
          src="assets/brand/explo-horizontal-blanco.svg"
          alt="Explorandes"
          class="brand-header-logo"
        />
      </a>

      <span class="app-module-eyebrow-badge">Alimentos &amp; Bebidas</span>
    </div>

    <div class="toolbar-right-group">
      <button
        mat-icon-button
        type="button"
        class="btn-exit-header"
        (click)="signOut()"
        matTooltip="Cerrar sesión"
        aria-label="Cerrar sesión"
      >
        <i-tabler name="power" class="exit-icon"></i-tabler>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-drawer-container class="app-drawer-container" autosize>
  <mat-drawer
    #drawer
    class="app-nav-drawer"
    [mode]="'side'"
    [opened]="openDrawer"
    (openedChange)="handleDrawerOpenedChange($event)"
  >
    <!-- Navigation Menu Groups -->
    <div class="drawer-nav-scroll-area">
      <nav
        class="drawer-nav-sections"
        aria-label="Menú principal de navegación"
      >
        <div
          *ngFor="let routeSection of menuRoutes; let sectionIndex = index"
          class="nav-section-group"
        >
          <div class="section-heading-row">
            <span class="section-heading-text">{{ routeSection.menu }}</span>
          </div>

          <div class="section-items-list">
            <a
              *ngFor="let subItem of routeSection.subMenu"
              [routerLink]="subItem.route"
              routerLinkActive="active-nav-link"
              [routerLinkActiveOptions]="{ exact: false }"
              class="nav-menu-link-item"
              [matTooltip]="subItem.name || ''"
              matTooltipPosition="right"
            >
              <div class="link-icon-shell">
                <i-tabler
                  [name]="subItem.icon || 'circle'"
                  class="nav-item-icon"
                ></i-tabler>
              </div>
              <span class="nav-item-label">{{ subItem.name }}</span>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </mat-drawer>

  <mat-drawer-content class="app-main-content-pane">
    <div *ngIf="isTokenReady" class="pageWrapper">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
